import React from 'react';

import { useMediaQuery } from '@/hooks/shared/useMediaQuery';

import Indicator from '@/components/apps/ui/indicator/Indicator';
import { IndicatorItemType } from '@/components/apps/ui/indicator/IndicatorItem';
import SectionTitle from '@/components/apps/ui/title/SectionTitle';

import theme from '@/styles/theme';

import SolutionItem from './SolutionItem';
import { SolutionItemProps } from './solutionItemTypes';

type SolutionContentProps = {
  title: React.ReactNode;
  indicatorItems: IndicatorItemType[];
  solutionItems: Omit<SolutionItemProps, 'idPrefix' | 'index' | 'isDesktop'>[];
  idPrefix: string;
};

export default function SolutionContent({
  title,
  indicatorItems,
  solutionItems,
  idPrefix,
}: SolutionContentProps) {
  const isDesktop = useMediaQuery({
    query: `(min-width: ${theme`screens.lg`})`,
  });

  return (
    <div className="grid gap-10 lg:gap-[clamp(40px,6.667vw,80px)]">
      <SectionTitle title={title} />
      <div className="lg:grid lg:grid-cols-[227px_auto] lg:gap-[clamp(20px,7.76vw,149px)]">
        <div className="hidden lg:block lg:w-[227px]">
          {isDesktop ? <Indicator items={indicatorItems} /> : null}
        </div>
        <div className="flex flex-col gap-[100px] lg:gap-[clamp(100px,16.667vw,200px)]">
          {solutionItems.map((item, index) => (
            <SolutionItem
              {...item}
              isDesktop={isDesktop}
              index={index}
              key={index}
              idPrefix={idPrefix}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
